/* global System */

export default {
  TextTeaser: () =>
    System.import(/* webpackChunkName: "TextTeaser" */ './index'),
}
